import { GenericDrawer, Image3D, ModalService, useRouter } from '@capsicum/common-web';
import {
	FanTokenErrorModalButtonBehaviour,
	fanTokenOfferingAPIErrorModalAtom,
	type FTOErrorModalParams
} from '@capsicum/features/fan-token-offering/shared';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

type UseFanTokenOfferingErrorModalHandlerProps = {
	fanTokenOfferingId: string;
};

export const useFanTokenOfferingErrorModalHandler = ({
	fanTokenOfferingId
}: UseFanTokenOfferingErrorModalHandlerProps) => {
	const [fanTokenOfferingAPIErrorModal, setFanTokenOfferingAPIErrorModal] = useAtom(
		fanTokenOfferingAPIErrorModalAtom
	);
	const { back, push } = useRouter();

	const handleRedirect = (behaviour?: FTOErrorModalParams['onMainButtonPressBehaviour']) => {
		if (behaviour === FanTokenErrorModalButtonBehaviour.RedirectToFirstPage) {
			push(`/fan-token-offering/${fanTokenOfferingId}`);
		} else if (behaviour === FanTokenErrorModalButtonBehaviour.RedirectToMainApp) {
			back(); // TODO: Check if we should navigate('Home') instead
		}
	};

	const displayErrorModal = (params: FTOErrorModalParams) => {
		ModalService.addModal({
			detached: true,
			isClosable: false,
			renderComponent: ({ close }) => (
				<GenericDrawer
					{...params}
					image={<Image3D image={params.image} testID={`${params.testID}-image`} />}
					isButtonFullWidth
					isButtonOnRow={false}
					testID={params.testID}
					onButtonPress={() => {
						setFanTokenOfferingAPIErrorModal({ visible: false });
						close();
						params.onMainButtonPress?.();
						params.onMainButtonPressBehaviour && handleRedirect(params.onMainButtonPressBehaviour);
					}}
					onSecondaryActionOnButtonPress={() => {
						setFanTokenOfferingAPIErrorModal({ visible: false });
						close();
						params.onSecondaryButtonPress?.();
						params.onSecondaryButtonPressBehaviour &&
							handleRedirect(params.onSecondaryButtonPressBehaviour);
					}}
				/>
			)
		});

		return;
	};

	useEffect(() => {
		if (fanTokenOfferingAPIErrorModal.visible) {
			displayErrorModal(fanTokenOfferingAPIErrorModal.data);
			// Reset the modal state after displaying it
			setFanTokenOfferingAPIErrorModal({ visible: false });
		}
	}, [fanTokenOfferingAPIErrorModal]);
};
